export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export const PASSWORD_COMPLEXITY_MESSAGE =
  "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character";

export const PASSWORD_MAX_LENGTH_MESSAGE =
  "Password cannot exceed 128 characters";

export const PASSWORD_REQUIREMENTS_HINT = PASSWORD_COMPLEXITY_MESSAGE;

export const PASSWORD_REQUIREMENT_ITEMS = [
  "At least 8 characters long",
  "At least one uppercase letter",
  "At least one lowercase letter",
  "At least one number",
  "At least one special character",
] as const;

const SPECIAL_CHAR_REGEX = /[^A-Za-z0-9]/;

export function getPasswordComplexityErrors(password: string): string[] {
  const errors: string[] = [];

  if (!password) {
    return errors;
  }

  if (password.length > PASSWORD_MAX_LENGTH) {
    errors.push(PASSWORD_MAX_LENGTH_MESSAGE);
  }
  if (password.length < PASSWORD_MIN_LENGTH) {
    errors.push("Password must be at least 8 characters long");
  }
  if (!/[A-Z]/.test(password)) {
    errors.push("Password must contain at least one uppercase letter");
  }
  if (!/[a-z]/.test(password)) {
    errors.push("Password must contain at least one lowercase letter");
  }
  if (!/\d/.test(password)) {
    errors.push("Password must contain at least one number");
  }
  if (!SPECIAL_CHAR_REGEX.test(password)) {
    errors.push("Password must contain at least one special character");
  }

  return errors;
}

export function getPasswordComplexitySummaryErrors(password: string): string[] {
  const errors: string[] = [];

  if (!password) {
    return errors;
  }

  if (password.length > PASSWORD_MAX_LENGTH) {
    errors.push("Maximum 128 characters");
  }
  if (password.length < PASSWORD_MIN_LENGTH) {
    errors.push("At least 8 characters");
  }
  if (!/[A-Z]/.test(password)) {
    errors.push("One uppercase letter");
  }
  if (!/[a-z]/.test(password)) {
    errors.push("One lowercase letter");
  }
  if (!/\d/.test(password)) {
    errors.push("One number");
  }
  if (!SPECIAL_CHAR_REGEX.test(password)) {
    errors.push("One special character");
  }

  return errors;
}

export function isPasswordComplexityValid(password: string): boolean {
  return getPasswordComplexityErrors(password).length === 0;
}

export function assertPasswordComplexity(password: string): void {
  const errors = getPasswordComplexityErrors(password);
  if (errors.length > 0) {
    throw new Error(errors[0]);
  }
}

export function formatPasswordComplexitySummary(password: string): string {
  const errors = getPasswordComplexitySummaryErrors(password);
  if (errors.length === 0) {
    return "";
  }

  return `Password must include: ${errors.join(", ")}`;
}
